/* jshint expr: true */
/* jshint latedef: nofunc */
(function ( $, window, document, undefined ) {

    var defaults = {
            timing: 0.75,
            ripple: '.js-ripple'
        };
    
    function WaveEffect (el, options) {
        this.el = el;
        this.settings = $.extend( {}, defaults, options );
        this.target = document.getElementById(this.settings.targetId);
        this.ripple = document.querySelectorAll(this.settings.ripple);
    }
 
    WaveEffect.prototype.rippleAnimation = function(event) {
    
        var offset = $(this.target).offset();
        var posY = offset.top - $(window).scrollTop();
        var posX = offset.left - $(window).scrollLeft(); 
    
        var tl           = new TimelineMax();
            x            = event.clientX - posX,
            y            = event.clientY - posY,
            w            = this.target.offsetWidth,
            h            = this.target.offsetHeight,
            offsetX      = Math.abs( (w / 2) - x ),
            offsetY      = Math.abs( (h / 2) - y ),
            deltaX       = (w / 2) + offsetX,
            deltaY       = (h / 2) + offsetY,
            scale_ratio  = Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    
        tl.fromTo(this.ripple, this.settings.timing, {
          x: x,
          y: y,
          transformOrigin: '50% 50%',
          scale: 0,
          opacity: 1,
          ease: Linear.easeIn
        },{
          scale: scale_ratio,
          opacity: 0
        });

        return tl;
    };
    
    $.fn.waveEffect = function ( options ) {
        
        var plugin = new WaveEffect(this, options);
        
        
        return this.each(function () {
            $(this).on('click', function(event) {
                plugin.rippleAnimation(event);                
            });
            return this;
        });
    };

})( jQuery, window, document );
